/**
 * ด่านฝั่งจอของ alert เคสซ่อม — feedback ทิวากร 7 ก.ย. 2026 (/maintenance/list):
 * "หากเปิดเคสและเลือกสถานะ 'ปิด' (จบเคสแล้ว) ควรไม่ต้องมีแจ้ง Alert"
 *
 * backend เลิกยิง `maintenance_new` ให้เคสที่เกิดมาเป็น CLOSED/CANCELLED แล้ว (endpoints/device_maintenance.py)
 * แต่จอต้องกันอีกชั้น: prod อาจยัง run backend รุ่นก่อน (deploy คนละรอบ) และ event จากแหล่งอื่น/ข้อมูลเก่า
 * ที่ status เป็นสถานะจบแล้ว ไม่ควร highlight แดง / popup / เสียง / กระดิ่ง เหมือนเคสใหม่
 */
export const TERMINAL_MAINTENANCE_STATUSES: ReadonlySet<string> = new Set(['CLOSED', 'CANCELLED']);

export function isTerminalMaintenanceStatus(status: unknown): boolean {
  return TERMINAL_MAINTENANCE_STATUSES.has(String(status ?? '').toUpperCase());
}

/**
 * true = event "เคสใหม่" นี้เป็นเคสที่จบตั้งแต่เกิด → ไม่ต้องแจ้งเตือน
 * (เฉพาะ type `maintenance_new` — `maintenance_completed`/`update` ที่ status จบยังต้องผ่านไปปลด highlight)
 */
export function isClosedAtBirthAlert(message: { type?: string; data?: { status?: unknown } | null } | null | undefined): boolean {
  if (!message || message.type !== 'maintenance_new') return false;
  return isTerminalMaintenanceStatus(message.data?.status);
}
